import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-x-6 w-8/12 space-y-3" }
const _hoisted_3 = { class: "my-1.5" }
const _hoisted_4 = { class: "my-1.5" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_6 = { class: "grid grid-cols-2 gap-x-6 w-8/12 space-y-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_NestedCheckbox = _resolveComponent("NestedCheckbox")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.titlePage,
    "full-page": "",
    "custom-class": "px-0",
    "vertical-separator": false,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[16] || (_cache[16] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage,
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSaveForm,
          disabled: !_ctx.isFormValid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode(_component_Title, { label: "Detail Promo" }),
      _createVNode("div", _hoisted_2, [
        (!_ctx.isFormTypeAdd)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              class: "col-span-2",
              label: "Promo ID",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.promoId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.promoId = $event)),
                  placeholder: "promo ID",
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Nama Promo",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.promoName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.promoName = $event)),
              placeholder: "Masukkan nama promo",
              disabled: _ctx.formDisabled('promoName'),
              disableBackground: _ctx.formDisabled('promoName')
            }, null, 8, ["modelValue", "disabled", "disableBackground"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Kota Asal",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Kota Asal Terpilih",
                "option-name": "kota",
                onFocus: _ctx.fetchCity,
                onFilter: _ctx.filterCity,
                options: _ctx.cityOptions,
                modelValue: _ctx.form.originCities,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.originCities = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: "Ketik atau pilih alamat asal",
                isLoading: _ctx.isLoadingCity,
                showReset: "",
                "able-to-delete-in-modal": "",
                isDisabled: _ctx.formDisabled('originCities'),
                disableBackground: _ctx.formDisabled('originCities')
              }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "isDisabled", "disableBackground"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Kota Tujuan",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Kota Tujuan Terpilih",
                "option-name": "kota",
                onFocus: _ctx.fetchCity,
                onFilter: _ctx.filterCity,
                options: _ctx.cityOptions,
                modelValue: _ctx.form.destinationCities,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.destinationCities = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: "Ketik atau pilih alamat tujuan",
                isLoading: _ctx.isLoadingCity,
                showReset: "",
                "able-to-delete-in-modal": "",
                isDisabled: _ctx.formDisabled('destinationCities'),
                disableBackground: _ctx.formDisabled('destinationCities')
              }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "isDisabled", "disableBackground"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Produk Pengiriman",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              options: _ctx.listProductDelivery,
              selectedItem: _ctx.form.products,
              "onUpdate:selectedItem": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.products = $event)),
              modelValue: _ctx.form.products,
              placeholder: "Pilih produk",
              class: "my-1.5",
              expandUpwards: true,
              disableBackground: _ctx.formDisabled('products'),
              isDisabled: _ctx.formDisabled('products')
            }, null, 8, ["options", "selectedItem", "modelValue", "disableBackground", "isDisabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Berat Acuan",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              options: _ctx.listReferenceWeight,
              selectedItem: _ctx.form.referenceWeight,
              "onUpdate:selectedItem": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.referenceWeight = $event)),
              modelValue: _ctx.form.referenceWeight,
              placeholder: "Pilih berat acuan",
              class: "my-1.5",
              expandUpwards: true,
              isDisabled: _ctx.formDisabled('referenceWeight'),
              disableBackground: _ctx.formDisabled('referenceWeight')
            }, null, 8, ["options", "selectedItem", "modelValue", "isDisabled", "disableBackground"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Berat Minimal",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              modelValue: _ctx.form.minimumWeight,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.minimumWeight = $event)),
              format: _ctx.formatInputFloat,
              placeholder: "Masukkan berat minimal",
              suffix: "Kg",
              disabled: _ctx.formDisabled('minimumWeight'),
              disableBackground: _ctx.formDisabled('minimumWeight'),
              error: _ctx.minimumWeightValidity.error,
              errorCaption: _ctx.minimumWeightValidity.errorCaption,
              onChange: _ctx.changeMinimumWeightValidity
            }, null, 8, ["modelValue", "format", "disabled", "disableBackground", "error", "errorCaption", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Berat Maksimal",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              modelValue: _ctx.form.maximumWeight,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.maximumWeight = $event)),
              format: _ctx.formatInputFloat,
              placeholder: "Masukkan berat maksimal",
              error: _ctx.maximumWeightValidity.error || _ctx.weightValidity.error,
              errorCaption: _ctx.maximumWeightValidity.errorCaption || _ctx.weightValidity.errorCaption,
              onChange: _ctx.changeMaximumWeightValidity,
              suffix: "Kg",
              disabled: _ctx.formDisabled('maximumWeight'),
              disableBackground: _ctx.formDisabled('maximumWeight')
            }, null, 8, ["modelValue", "format", "error", "errorCaption", "onChange", "disabled", "disableBackground"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Mulai",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DatePickerV2, _mergeProps(_ctx.propsStartDate, {
              class: "my-1.5",
              modelValue: _ctx.form.startDate,
              onSelected: _ctx.onSelectStartDate,
              disabled: _ctx.formDisabled('startDate')
            }), null, 16, ["modelValue", "onSelected", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Berakhir",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DatePickerV2, _mergeProps(_ctx.propsEndDate, {
              class: "my-1.5",
              modelValue: _ctx.form.endDate,
              onSelected: _ctx.onSelectEndDate
            }), null, 16, ["modelValue", "onSelected"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Jenis Promo",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              options: _ctx.listOfPromoUnique,
              selectedItem: _ctx.form.promoUnique,
              "onUpdate:selectedItem": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.promoUnique = $event)),
              modelValue: _ctx.form.promoUnique,
              placeholder: "Pilih tipe promo",
              class: "my-1.5",
              expandUpwards: true,
              isDisabled: _ctx.form.statusPromo !== 'pending' && !_ctx.isFormTypeAdd,
              disableBackground: _ctx.form.statusPromo !== 'pending' && !_ctx.isFormTypeAdd
            }, null, 8, ["options", "selectedItem", "modelValue", "isDisabled", "disableBackground"])
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createVNode(_component_Title, { label: "Aturan Diskon" }),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Tipe Promo Diskon",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CustomDropdown, {
              options: _ctx.listPromoType,
              selectedItem: _ctx.form.promoType,
              "onUpdate:selectedItem": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.promoType = $event)),
              placeholder: "Pilih tipe promo diskon",
              class: "my-1.5",
              isDisabled: "",
              disableBackground: "",
              onSelect: _ctx.onSelectPromoType
            }, null, 8, ["options", "selectedItem", "onSelect"])
          ]),
          _: 1
        }),
        (_ctx.isFormPromoTypeIsPercentage)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_DataWrapper, {
                label: "Persentase Diskon",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, _mergeProps({
                    modelValue: _ctx.form.promoAmount,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.promoAmount = $event)),
                    format: _ctx.formatInputNumberOnly,
                    placeholder: "Masukkan jumlah promo"
                  }, _ctx.discountValidity, {
                    suffix: "%",
                    disabled: _ctx.formDisabled('promoAmount'),
                    disableBackground: _ctx.formDisabled('promoAmount')
                  }), null, 16, ["modelValue", "format", "disabled", "disableBackground"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Maksimum Diskon",
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, {
                    modelValue: _ctx.form.maximumDiscount,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.maximumDiscount = $event)),
                    format: _ctx.formatInputNumberAbleZero,
                    placeholder: "Jumlah maksimum prormo",
                    suffix: "IDR",
                    disabled: _ctx.formDisabled('maximumDiscount'),
                    disableBackground: _ctx.formDisabled('maximumDiscount')
                  }, null, 8, ["modelValue", "format", "disabled", "disableBackground"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                class: "col-span-2",
                label: "Kalkulasi Parameter",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    options: _ctx.listPromoQuantifier,
                    selectedItem: _ctx.form.promoQuantifier,
                    "onUpdate:selectedItem": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.promoQuantifier = $event)),
                    placeholder: "Pilih Tipe",
                    class: "my-1.5",
                    isDisabled: _ctx.formDisabled('promoQuantifier'),
                    disableBackground: _ctx.formDisabled('promoQuantifier'),
                    expandUpwards: true
                  }, null, 8, ["options", "selectedItem", "isDisabled", "disableBackground"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isFormPromoTypeIsFlat)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_DataWrapper, {
                label: "Potongan Harga",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, {
                    modelValue: _ctx.form.promoAmount,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.promoAmount = $event)),
                    format: _ctx.formatInputNumberOnly,
                    placeholder: "Masukkan besaran potongan harga",
                    prefix: "IDR",
                    disabled: _ctx.formDisabled('maximumWeight'),
                    disableBackground: _ctx.formDisabled('maximumWeight')
                  }, null, 8, ["modelValue", "format", "disabled", "disableBackground"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Minimal Ongkos Kirim",
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, {
                    modelValue: _ctx.form.minimumTransaction,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.minimumTransaction = $event)),
                    format: _ctx.formatInputNumberAbleZero,
                    placeholder: "Jumlah minimal ongkos kirim",
                    prefix: "IDR",
                    disabled: _ctx.formDisabled('minimumTransaction'),
                    disableBackground: _ctx.formDisabled('minimumTransaction')
                  }, null, 8, ["modelValue", "format", "disabled", "disableBackground"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Digunakan Untuk",
          id: "checkbox-applied-to",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NestedCheckbox, {
              class: "mt-4",
              parent: _ctx.parentShipmentCheckbox,
              childItems: _ctx.childShipmentCheckbox,
              onParentUpdated: _ctx.onCheckAllShipment,
              onChildUpdated: _ctx.onCheckShipment
            }, null, 8, ["parent", "childItems", "onParentUpdated", "onChildUpdated"]),
            _createVNode(_component_CheckboxV2, {
              label: "Retail",
              class: "mt-4 mb-10",
              textSize: 14,
              keyName: "appliedToRetail",
              value: _ctx.form.appliedToRetail,
              disabled: _ctx.formDisabled('appliedToRetail'),
              "onUpdate:value": _ctx.onUpdateAppliedToRetail
            }, null, 8, ["value", "disabled", "onUpdate:value"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "leave-page-confirmation", "onLeavePage", "loading", "error", "errorType", "onTryAgain"]))
}